import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'
import Stats from 'components/Stats'

import contentImageUrl from '../static/img/project-residential_fairbridge-way.jpg'

const stats = [
  {
    label_left: "Saleable acreage",
    label_right: "30 acres/325 homes",
    bars: [
      {
        value: 244,
        max: 360
      }
    ]
  },
  {
    label_left: "Total development value (£M)",
    label_right: "90",
    bars: [
      {
        value: 326,
        max: 360
      }
    ]
  },
  {
    label_left: "To be sold in whole or 3 parts",
    bars: [
      {
        value: 1,
        max: 3
      },
      {
        value: 1,
        max: 3
      },
      {
        value: 1,
        max: 3
      }
    ]
  }
]

class Residential extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div className="container container--layer-up">
          <div className="layout layout--img-right layout--grey">
            <div className="layout__item copy--project">
              <SectionTitle
                align="left"
                intro
                icon="icon-residential.svg"
                title="Residential"
              />
              <p className="copy--bold-x">Fairbridge Way Burgess Hill Sussex</p>
              <p>GDL act as Development and Asset Manager for Fairbridge Developments Ltd. This former sewage treatment work of over 30 acres, closed in 1992, was originally allocated for employment uses. Demand for housing has outstripped employment need in this immediate area and after various attempts to resolve planning and redevelopment options an outline for 325 houses/units was granted in 2014. Since this time we have sought and secured technical approval to both S278 and S38 undertaken the site wide remediation works and are now implementing all road, drainage and site servicing to delivery 3 oven ready serviced plots to go to the market in autumn for sale in whole or part</p>
              <p>See aerial footage</p>

              <Stats stats={stats} />
            </div>
            <div className="layout__item" style={{ backgroundImage: `url(${contentImageUrl})`, backgroundSize: 'cover' }} />
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Residential;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Residential.js